import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 获取所有字典数据
export function getDictInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict',
    method: 'GET',
    params: parameter
  })
}

// 编辑字典数据
export function editDictInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict',
    method: 'PUT',
    data: parameter
  })
}

// 新增字典
export function createDictInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict',
    method: 'POST',
    data: parameter
  })
}

// 删除字典数据
export function deleteDictInfo (id) {
  return axios({
    url: sysInfo.apiRemote + `/dict/${id}`,
    method: 'DELETE'
  })
}

// 拖拽字典数据
export function dragDictInfo (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/dict/drag`,
    data: parameter,
    method: 'PUT'
  })
}

// 根据字典的pid或者pcode获取字典列表
export function getDictInfoByCode (parameter) {
  return axios({
    url: sysInfo.apiRemote + `/dict/query`,
    params: parameter,
    method: 'GET'
  })
}

// 获取所有字典数据
export function getDictData (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict/query',
    method: 'GET',
    params: parameter
  })
}
